import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGroupDelete } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchSliderGroupDelete = createAsyncThunk(
    'sliderGroupGet/fetchSliderGroupDelete',
    async ({ id }) => {
        const response = await SliderGroupDelete(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const sliderGroupDeleteSlice = createSlice({
    name: 'sliderGroupDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGroupDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGroupDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGroupDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGroupDeleteSlice.reducer;
